import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnActionsModule } from '@lib/ui/actions';
import { SnListModule } from '@lib/ui/list';
import { SnFormModule } from 'libs/form/src/lib/form.module';
import { SnButtonModule } from 'libs/ui/button/src/lib/button.module';
import { SnDataListModule } from 'libs/ui/data-list/src/lib/data-list.module';
import { SnIconModule } from 'libs/ui/icon/src/lib/icon.module';
import { SnSearchbarModule } from 'libs/ui/searchbar/src/lib/searchbar.module';

import { TranslationModule } from '@lib/translation/translation.module';
import { AddInheritPolicyDialogComponent } from './components/add-inherit-policy-dialog/add-inherit-policy-dialog.component';
import { AddPolicyDialogComponent } from './components/add-policy-dialog/add-policy-dialog.component';
import { TagsResourceComponent } from './components/camera-location-tag-resource/tags-resource/tags-resource.component';
import { CamerasResourceComponent } from './components/cameras-resource/cameras-resource.component';
import { EditPolicyGroupDialogComponent } from './components/edit-policy-group-dialog/edit-policy-group-dialog.component';
import { LayersSearchDialogComponent } from './components/layers-search-dialog/layers-search-dialog.component';
import { LocationsResourceComponent } from './components/locations-resource/locations-resource.component';
import { PermissionsSearchDialogComponent } from './components/permissions-search-dialog/permissions-search-dialog.component';
import { FsPolicyGroupsTableComponent } from './components/policy-groups-table/policy-groups-table.component';
import { PolicyUsersComponent } from './components/policy-users/policy-users.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatDialogModule,
    MatSortModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatTabsModule,
    MatTooltipModule,
    MatProgressBarModule,
    SnListModule,
    SnActionsModule,
    SnDataListModule,
    SnCommonModule,
    SnActionsModule,
    SnFormModule,
    SnButtonModule,
    SnIconModule,
    MatMenuModule,
    MatSelectModule,
    SnSearchbarModule,
    TranslationModule
],
  exports: [
    FsPolicyGroupsTableComponent,
    CamerasResourceComponent,
    LocationsResourceComponent,
    TagsResourceComponent,
    PolicyUsersComponent,
  ],
  declarations: [
    FsPolicyGroupsTableComponent,
    EditPolicyGroupDialogComponent,
    AddPolicyDialogComponent,
    PolicyUsersComponent,
    LocationsResourceComponent,
    CamerasResourceComponent,
    AddInheritPolicyDialogComponent,
    PermissionsSearchDialogComponent,
    TagsResourceComponent,
    LayersSearchDialogComponent,
  ],
})
export class PolicyGroupsModule {}
